import { z } from 'zod';
/** The 11 report keys covered by the generic `GET /reports/export/:reportKey` pipeline. */
export const ReportKeySchema = z.enum([
    'invoice-summary',
    'clients',
    'line-items',
    'revenue-timeline',
    'aging',
    'revenue-by-tag',
    'expenses',
    'tax',
    'bas-summary',
    'profit-and-loss',
    'aged-receivables',
]);
/**
 * Standing disclaimer — Regulatory Posture Rule 3 of the reporting-exports spec. Appears
 * verbatim on every report PDF footer, as a comment row atop every exported CSV, and
 * on-screen in each report section. Never varies per report.
 */
export const REPORT_DISCLAIMER = 'Prepared from your myTrellis records only. Figures are calculated from data you entered and may not reflect your full tax position — bank transactions, payroll, and anything recorded elsewhere are not included. myTrellis does not provide tax or financial advice. You are responsible for meeting your own reporting obligations. Review with a registered tax agent or accountant before relying on these figures.';
/**
 * Shown in place of the BAS summary when the organisation has declared it is not
 * GST-registered. States a fact about their settings, never a conclusion about their
 * legal position — Regulatory Posture Rule 1 of the reporting-exports spec.
 */
export const GST_REPORTING_OFF_MESSAGE = 'GST reporting is turned off in your tax settings.';
//# sourceMappingURL=reports.js.map